import { FC, HTMLAttributes, ReactNode, useState } from 'react';

import SvgChevronDown from '@/assets/icons/ChevronDown';
import ChevronUp from '@/assets/icons/ChevronUp';

import styles from './Details.module.css';
type DetailsProps = HTMLAttributes<HTMLDetailsElement> & {
  children: ReactNode;
  defaultOpen?: boolean;
  summary: ReactNode | string;
};
const Details: FC<DetailsProps> = ({ children, summary, defaultOpen = true, ...detailProps }) => {
  const [open, setOpen] = useState<boolean>(defaultOpen);
  return (
    <details className={styles.details} open={defaultOpen} onToggle={() => setOpen((prev) => !prev)} {...detailProps}>
      <summary className={styles.summary}>
        <div className={styles.summaryDiv}>
          {summary}
          {open ? (
            <SvgChevronDown fill={'var(--tractie-color-content-subtle)'} />
          ) : (
            <ChevronUp fill={'var(--tractie-color-content-subtle)'} />
          )}
        </div>
      </summary>
      {children}
    </details>
  );
};
export default Details;
